// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__CLc8u","opacity-transition":"error_opacity-transition__Kzppj"};